module.exports = __webpack_public_path__ + "img/连翘.1273a3ba.jpg";